var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.54169C1.49685 9.75157 1.77952 10.9451 2.325 12.025C2.97177 13.3191 3.96606 14.4076 5.19651 15.1685C6.42695 15.9295 7.84495 16.3328 9.29167 16.3334C10.5015 16.3365 11.6951 16.0538 12.775 15.5084L18 17.25L16.2583 12.025C16.8038 10.9451 17.0865 9.75157 17.0833 8.54169C17.0828 7.09497 16.6794 5.67697 15.9185 4.44653C15.1576 3.21609 14.0691 2.2218 12.775 1.57503C11.6951 1.02955 10.5015 0.746872 9.29167 0.750026H8.83333C6.92268 0.855435 5.11805 1.66189 3.76496 3.01498C2.41187 4.36807 1.60541 6.17271 1.5 8.08336V8.54169Z",
    stroke: "#9D9D9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostMessage);
export default __webpack_public_path__ + "static/media/post-message.fe556e57699b149f3c13b39e5127f05b.svg";
export { ForwardRef as ReactComponent };